<template>
  <div class="slim-card">
    <img class="slim-card__img" :src="src" alt="pic" />

    <div class="slim-card__txt">
      <UiText
        :text="title"
        color="typography-title01"
        font="components-card-title"
        class="slim-card__title"
      />
      <UiText
        :text="desc"
        color="typography-body01"
        font="body-caption"
        class="slim-card__subtitle"
      />
    </div>

    <div v-if="games && games.length" class="slim-card__games">
      <div v-for="game in games" :key="game.iconUrlVertical" class="slim-card__game">
        <img v-lazy="`${$config.cloudUrl}${game.iconUrlVertical}`" alt="pic game" class="slim-card__game-pic" />
      </div>
      <div v-if="remainder" class="slim-card__amount">
        <UiText
          class="slim-card__amount-txt"
          :font="{ 'default': 'body-caption-small', 'tablet-album' : 'body-caption' }"
          :text="`+${remainder}`"
        />
      </div>
    </div>
    <div v-else class="slim-card__empty-games" />

    <div class="slim-card__action">
      <UiBtn
        :text="$t('cards.to')"
        full-width
        size="m"
        color="default"
        :to="to"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlimCategoryCard',
  props: {
    to: { type: String, required: true },
    title: { type: String, required: true },
    desc: { type: String, required: true },
    src: { type: String, required: true },
    games: { type: Array, required: true },
    remainder: { type: Number },
  },
}
</script>

<style lang="scss" scoped src="./style.scss" />
